import DateInput from "app/components/DateInput/DateInput";

export default DateInput;